import "./_error.scss";

import cx from "classnames";
import {ReactElement} from "react";

import Button from "@/components/Button/Button";

export function ErrorComponent({
  image,
  text,
  variant = "red",
  buttonToRefresh = false,
}: {
  image?: string;
  text: string;
  variant?: "red" | "orange" | "bleu";
  buttonToRefresh?: boolean;
}): ReactElement {
  const errorVariant = (
    variant: "red" | "orange" | "bleu",
  ): {
    "error-red": boolean;
    "error-orange": boolean;
    "error-blue": boolean;
  } => {
    return {
      "error-red": variant.includes("red"),
      "error-orange": variant.includes("orange"),
      "error-blue": variant.includes("blue"),
    };
  };

  const handleReload = (): void => {
    location.reload();
  };
  const illustration = image ? (
    <img src={image} alt="Icon d'erreur" loading="lazy" />
  ) : null;
  return (
    <div className="error">
      <div className={cx("error-content", errorVariant(variant))}>
        {illustration}
        <div>
          <p>{text}</p>
          {buttonToRefresh ? (
            <Button
              label={"Revenir à l'accueil"}
              onClick={() => handleReload()}
              variant="secondary"></Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
